import dayjs from 'dayjs';
import { IUser } from 'app/shared/model/user.model';

export interface IAnnouncement {
  id?: number;
  imageName?: string | null;
  topics?: string | null;
  description?: string | null;
  link?: string | null;
  createdDate?: string | null;
  modifiedDate?: string | null;
  user?: IUser | null;
}

export const defaultValue: Readonly<IAnnouncement> = {};
